import {
  NBS_API_FINISH_WEB_PAYMENT_REQUEST,
  NBS_API_FINISH_WEB_PAYMENT_SUCCESS,
  NBS_API_FINISH_WEB_PAYMENT_FAILURE,
  RESET_FINISH_WEB_PAYMENT
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_FINISH_WEB_PAYMENT_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request'
      };
    case NBS_API_FINISH_WEB_PAYMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success'
      };
    case NBS_API_FINISH_WEB_PAYMENT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail'
      };
    case RESET_FINISH_WEB_PAYMENT:
      return initialState;
    default:
      return state;
  }
}
